import React from 'react'
import { TbMail, TbPencil, TbPhone, TbUserCode, TbDownload } from 'react-icons/tb'
import { useEmployeeContext } from '../../context/employee-context'
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Button, Chip, Col, Flex, Icon, Row, Typography } from '../../ppui'
// import { logger } from '../../utils/logger'
import { EmployeeHeader, EmployeeName, EmployeeWrapper, PhotoView, } from '../style'
import ProfileDialog from './profile/profile-dialog'
import useEmployeeProfileService from './profile/use-profile-service'
// import EmployeeCover from '../../assets/svgs/employee-cover-svg'
import EmployeeCover from '../../assets/svgs/cover-svg'
import { toCapitaliseStringType1 } from '../../utils/common'
import EmployeeDocument from "./emp-pdf-react";
import { logger } from '../../utils/logger';
import useOrgDetailsService from '../organization-details/use-orgdetails-service';
import useOrgDetailsFullDataHook from '../../lib/useOrgFullDetails';


const EmployeeStickyProfileInfoHeader = () => {
  const {
    employeeInfo: imployeeInfoFromDB,
    branchList,
    departmentList,
    designationList,
    stateList
  } = useEmployeeContext() || {};
  const {
    getInputFieldProps,
    // setEmployeeProfileInput,
    // fileInputRef,
    // previewURL,
    createFormUpdateLoading,
    // setSelectedFile,
    // setPreviewURL,
    employeeProfileInput,
    handleClick,
    // togglePresentAddress,
    // EmployeedetailsModalOpen,
    PresentaddressModalClose,
    // PresentaddressModalOpen,
    PermanentaddressModalClose,
    // PermanentaddressModalOpen,
    PersonalInformationModalClose,
    // PersonalInformationModalOpen,
    EmployeedetailsModalClose,
    Permanentaddress,
    PersonalInformation,
    Presentaddress,
    Employeedetails,
    // SubmitWithNextBtn,
    // SubmitAfterView,
    employeeProfile,
    employeeProfileModalOpen,
    employeeProfileModalClose,
    setSelectedFile,
    handleFileChange,
    previewURL,
    setPreviewURL,
    setEmployeeProfileInput
  } = useEmployeeProfileService();
  // const { showToastMessage } = useToast();
  // const fileInputRef = useRef()
  const {
    orgDetails
  }=useOrgDetailsService();
  const{organizationFullInfo}=useOrgDetailsFullDataHook()

  if (!imployeeInfoFromDB?.first_name) {
    return null;
  }
  logger.log("imployeeInfoFromDB", imployeeInfoFromDB)
logger.log("orgDetails000",orgDetails)

  return (
    <>
      {/* <ContentHeading>
        <Typography variant="h5" mb="0">
          Employee Details
        </Typography>
      </ContentHeading> */}
      <EmployeeWrapper>
        <EmployeeHeader>
          <EmployeeCover />
          <PhotoView>
            {imployeeInfoFromDB?.logo ?

              <img src={`${imployeeInfoFromDB?.logo}`} />
              :
              <>
                {/* <TbUserEdit/> */}
                {imployeeInfoFromDB?.first_name.trim().substring(0, 1).toUpperCase()}
                {imployeeInfoFromDB?.last_name.trim().substring(0, 1).toUpperCase()}
              </>
            }
          </PhotoView>
          <EmployeeName>



            <Row  >
              <Col>
                <Typography variant='h3' color="light" textCase="capitalize" mb="0" colorVariant="light">
                  {/* {imployeeInfoFromDB?.full_name} */}
                  {imployeeInfoFromDB?.first_name}&nbsp;
                  {imployeeInfoFromDB?.last_name}
                </Typography>
              </Col>
              <Col sm={"auto"}>
                <Chip
                  color={imployeeInfoFromDB?.status === "onboarding" ? "info" : imployeeInfoFromDB?.status === "active" ? "success" : "danger"}
                  label={imployeeInfoFromDB?.status ? toCapitaliseStringType1(imployeeInfoFromDB?.status) : "N/A"}
                  onClick={() => { }}
                  size='sm'
                  variant={"contained"}
                />
              </Col>
            </Row>
            <Row alignItem="flex-end" >
              <Col>
                <Flex alignItem="center" gap={5}>
                  <Icon color={"light"}>
                    <TbUserCode />
                  </Icon>
                  <Typography variant="body2" mb={"0"} color="light" colorVariant="dark">
                    #{imployeeInfoFromDB?.employee_code ? imployeeInfoFromDB?.employee_code : 'N/A'}
                  </Typography>
                </Flex>
                <Flex alignItem="center" gap={5}>
                  <Icon color={"light"}>
                    <TbPhone />
                  </Icon>
                  <Typography variant="body2" mb={"0"} color="light" colorVariant="dark">
                    {imployeeInfoFromDB?.phone ? imployeeInfoFromDB?.phone : 'N/A'}
                  </Typography>
                  {imployeeInfoFromDB?.alternative_phone &&
                    <Typography variant="body2" mb={"0"} color="light" colorVariant="dark">
                      / {imployeeInfoFromDB?.alternative_phone}
                    </Typography>
                  }
                </Flex>
                <Flex alignItem="center" gap={5}>
                  <Icon color={"light"}>
                    <TbMail />
                  </Icon>
                  <Typography variant="body2" mb={"0"} color="light" colorVariant="dark">
                    {imployeeInfoFromDB?.email ? imployeeInfoFromDB?.email : 'N/A'}
                  </Typography>
                </Flex>
              </Col>
              <Col sm={"auto"}>
                <Button variant='filled' color='light' size='sm'
                  icon={<TbPencil />}
                  onClick={employeeProfileModalOpen}
                >Edit
                </Button>
              </Col>
              <Col sm={"auto"}>
                <PDFDownloadLink
                  document={
                    <EmployeeDocument
                      data={imployeeInfoFromDB}
                      branchList={branchList}
                      orgDetails={orgDetails}
                      departmentList={departmentList}
                      designationList={designationList}
                      stateList={stateList}
                      organizationFullInfo={organizationFullInfo}
                    />
                  }
                  fileName={`${imployeeInfoFromDB?.first_name}-${imployeeInfoFromDB?.last_name}-info.pdf`}
                >
                  {({ loading }) => (
                    <Button
                      variant="filled"
                      color="light"
                      size="sm"
                      icon={<TbDownload />}
                      disabled={loading}
                    >
                      {loading ? 'Preparing...' : 'Download Info'}
                    </Button>
                  )}
                </PDFDownloadLink>
              </Col>
            </Row>
          </EmployeeName>
        </EmployeeHeader>
      </EmployeeWrapper>
      <ProfileDialog
        createFormUpdateLoading={createFormUpdateLoading}
        employeeProfileInput={employeeProfileInput}
        getInputFieldProps={getInputFieldProps}
        Presentaddress={Presentaddress}
        PresentaddressModalClose={PresentaddressModalClose}
        PermanentaddressModalClose={PermanentaddressModalClose}
        Permanentaddress={Permanentaddress}
        PersonalInformationModalClose={PersonalInformationModalClose}
        PersonalInformation={PersonalInformation}
        EmployeedetailsModalClose={EmployeedetailsModalClose}
        Employeedetails={Employeedetails}
        handleClick={handleClick}
        employeeProfile={employeeProfile}
        employeeProfileModalOpen={employeeProfileModalOpen}
        employeeProfileModalClose={employeeProfileModalClose}
        setSelectedFile={setSelectedFile}
        handleFileChange={handleFileChange}
        previewURL={previewURL}
        setPreviewURL={setPreviewURL}
        setEmployeeProfileInput={setEmployeeProfileInput}
      />
    </>
  )
}

export default EmployeeStickyProfileInfoHeader